/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Bonisoft Backend API
 * Bonisoft Backend API
 * OpenAPI spec version: 1
 */

export type StatusPayoutInterval = typeof StatusPayoutInterval[keyof typeof StatusPayoutInterval];


export const StatusPayoutInterval = {
  Daily: 'Daily',
  Weekly: 'Weekly',
  Monthly: 'Monthly',
} as const;
